
import { httpss } from "../utils/host";
export const createRoute = `${httpss}/apis_v1/userEvent/create`;
export const getRoute = `${httpss}/apis_v1/userEvent/getUserEvent`;
export const checkIsCaptain = `${httpss}/apis_v1/userEvent/checkIsCaptain`;
export const checkIsAdmin = `${httpss}/apis_v1/userEvent/checkIsAdmin`;